import Facebook from './Facebook-view';

export default Facebook;
